export default __webpack_public_path__ + "static/media/easyPaisaIcon.bb3d8e9d.svg";